export default {"src":"/_next/static/media/text-404.279032a4.svg","height":34,"width":86,"blurWidth":0,"blurHeight":0};